import React, { createContext } from 'react';
import { DecodeDateRange } from '../../decode-filters';




export type WsDecodeContextProps = {

  selectedDateRange: DecodeDateRange;

  setSelectedDateRange: React.Dispatch<React.SetStateAction<DecodeDateRange>>;
  

  selectedRegionalPartnershipId: string;

  setSelectedRegionalPartnershipId: React.Dispatch<React.SetStateAction<string>>;



  selectedLocalAuthorityId: string;

  setSelectedLocalAuthorityId: React.Dispatch<React.SetStateAction<string>>;



  selectedSchoolTypeId: string;

  setSelectedSchoolTypeId: React.Dispatch<React.SetStateAction<string>>;



  selectedSchoolId: string;

  setSelectedSchoolId: React.Dispatch<React.SetStateAction<string>>;

};




// const decodeContextDefaultProps: WsDecodeContextProps = {
// };




const WsDecodeContext = createContext<WsDecodeContextProps | undefined>(undefined);




export {
  WsDecodeContext
};
